import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

// ReactDOM.render(<App />, document.getElementById("root"));

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

const container = document.getElementById('root')
const root = createRoot(container) // Create a root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
